import { CardActionArea, Chip, Typography } from "@mui/material";
import { Box } from "@mui/system";
import React, { useEffect, useState } from "react";
import he from 'he';
import { Link as RouterLink } from "react-router-dom";
import axios from "axios";

export default function ExperienceCard({ post }){

    const [partner, setPartner]=useState();

    useEffect(()=>{
        axios({
            method: 'get',
            url: `${WP_API_Settings.endpoint}wp/v2/partners/${post.partners[0]}?_embed=true&acf_format=standard`,
        })
        .then(response => {
            setPartner(response.data);
        })
        .catch(error => {
            console.error('Error fetching partners:', error);
        });
    }, []);


    return(
        <CardActionArea
            component={RouterLink}
            to={post.link}
            onMouseDown={e=>e.preventDefault()}
            sx={{
                '&:hover': {
                    '& .MuiCardActionArea-focusHighlight': {
                        opacity: 0,
                    },
                    '& .card-image': {
                        opacity: '1!important',
                    },
                },
            }}
        >
            <Box
                sx={{
                    position: 'relative',
                }}
            >
                <Box
                    style={{
                        width: '100%',
                        height: '300px',
                        position: 'relative',
                    }}
                >
                    <Box
                        className="card-image"
                        style={{
                            position: 'absolute',
                            width: '100%',
                            height: '100%',
                            backgroundColor: 'rgba(53, 92, 160, 0.2)',
                            opacity: 0,
                            transition: 'opacity 0.3s',
                            zIndex: 1,
                        }}
                    />
                    <img
                        alt={post.title.rendered}
                        src={post._embedded['wp:featuredmedia'][0].source_url}
                        style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                        }}
                    />
                </Box>
                <Box
                    sx={{
                        height: '51px',
                        width: '90px',
                        margin: '12px 0 10px 0',
                    }}
                >
                    <img
                        alt={partner?.name}
                        src={partner?.acf.logo}
                        style={{
                            width: '100%',
                            objectFit: 'contain',
                        }}
                    />
                </Box>
                <Typography
                    variant="h3"
                    sx={{
                        color: "#E9531C",
                        fontSize: "1.2rem",
                        fontWeight: 600,
                        marginBottom: "10px",
                    }}
                >
                    {he.decode(post.title.rendered)}
                </Typography>
                <Typography variant='p' component='p'
                    sx={{
                        pb:'2rem'
                    }}
                >
                    {he.decode(post.excerpt.rendered)}
                </Typography>
            </Box>
        </CardActionArea>
    );
}